import { z } from 'zod'

export const roleSchema = z.object({
  display_name: z.string().min(3, 'Campo Nome deve ter no mínimo 3 caracteres'),
  description: z.string().min(3, 'Campo Descrição deve ter no mínimo 3 caracteres'),
  level: z.string().optional().nullable(),
  permit_reset_client_user_password_by_others: z.boolean().optional(),
})

export type RoleValidationSchema = z.infer<typeof roleSchema>
